"use strict";
var AjaxObservable_1 = require('./AjaxObservable');
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/dom/ajax.js
 ** module id = 127
 ** module chunks = 2
 **/